import React, { useState,useEffect } from "react";
import axios from "axios";
import GoogleMapReact from "google-map-react";

import MyMarker from "../components/ClientApplication/MyMarker";
import {aPIURL} from '../utils/common';
import "../assets/css/style.css"


// implementation of this function is needed for codesandbox example to work
// you can remove it otherwise
const distanceToMouse = (pt, mp) => 
  {
  if (pt && mp) {
    // return distance between the marker and mouse pointer
    return Math.sqrt(
      (pt.x - mp.x) * (pt.x - mp.x) + (pt.y - mp.y) * (pt.y - mp.y)
    );
  }
};

//const points = [ { id: 1, title: "Round Pond", lat: 28.401042, lng: 77.345674 },  { id: 2, title: "The Long Water", lat: 28.400137, lng: 77.346969 },  { id: 3, title: "The Serpentine", lat: 28.399913, lng: 77.346817 }];

   
export default function MapPoligone()
 {
  let [lat, setLatitude] = useState();//28.61394, lng:77.20902
  let [long, setLlongitude] = useState();
  const API_URL=aPIURL();         
  const [points,setPoints] =useState([]);

  useEffect(() => {
  
    
    
    
    const daurls=API_URL+`RoutePoints?VehicleNO=HR%2051%20BM7697`; 
    // alert(daurls);          
    const response =  axios.get(daurls).then(response => 
    {       
     setPoints(response.data);

     setLatitude(response.data[0].lat);
     setLlongitude(response.data[0].lng);
    console.log(response.data);
    // alert(response.data[0].lat);
     console.log("---------------Pointsitems--------------------"); 
     console.log(lat);
     }).catch(function(error) 
     {
      //console.log(error.message);
      }); 

     
    
  }, []);


      
    const defaultProps = 
    {
      
      center: {
        lat:28.387816 ,
        lng:77.35126 
      },
      zoom: 12
    }; 
  
    
 
  useEffect(() => {
      let interval = setInterval(() => 
      {    
        
                
        const daurls=API_URL+`RoutePoints?VehicleNO=HR%2051%20BM7697`; 
        // alert(daurls);          
        const response =  axios.get(daurls).then(response => 
        {       
         setPoints(response.data);
          console.log("---------------Pointsitems--------------------"); 
       console.log(response.data);
      }).catch(function(error) 
      {
        console.log(error.message);
        }); 
      }, 20000);
  
    return () => clearInterval(interval);
  }, []);
          
    
  
    return (
    <div className="App">
      ;
      <GoogleMapReact
        bootstrapURLKeys={{
          // remove the key if you want to fork
          key: process.env.REACT_APP_MAPKEY,
          language: "en",
          region: "US"
        }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        
       // distanceToMouse={distanceToMouse}
      >
        {points.map(({ lat, lng, id}) => 
        {
          
          return (
                  <MyMarker key={id} lat={lat} lng={lng} text={id} tooltip={'title'} />
                );
        })}
      </GoogleMapReact>
    </div>
  );
 
  
    
}